import styled from 'styled-components';

import colors from 'styles/colors';

export const PaginatedSentinelStyled = styled.div`
  padding: 8px 12px;
  color: ${colors.gray_scale10};
  font-size: 14px;
  text-align: center;
`;

export const PaginatedErrorStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  color: ${colors.error_scale2};
  font-size: 14px;
`;

export const PaginatedRetryStyled = styled.button`
  background: none;
  border: none;
  color: ${colors.brand_2};
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 4px 8px;

  &:hover {
    text-decoration: underline;
  }
`;
